import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useUserFollowingCount(userId?: string) {
  const { user: authUser } = useAuth();
  const [followingCount, setFollowingCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchFollowingCount = async () => {
    // Use the provided userId or fallback to the authenticated user's ID
    const targetUserId = userId || authUser?.id;
    
    if (!targetUserId) {
      setFollowingCount(0);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const { data, error } = await supabase.rpc('get_following_count', {
        _user_id: targetUserId
      });

      if (error) {
        console.error('Error fetching following count:', error);
        throw error;
      }
      
      const count = Number(data) || 0;
      setFollowingCount(count);
    } catch (err) {
      console.error('Following count fetch error:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch following count');
      setFollowingCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFollowingCount();
  }, [userId, authUser?.id]);

  return {
    followingCount,
    loading,
    error,
    refetch: fetchFollowingCount
  };
}